export const AUTH = {
  LOGIN: 'LOGIN',
  LOGOUT: 'LOGOUT',
  REGISTER: 'REGISTER',
  LOGIN_PAGE_UNLOADED: 'LOGIN_PAGE_UNLOADED',
  REGISTER_PAGE_UNLOADED: 'REGISTER_PAGE_UNLOADED',
  ASYNC_START: 'ASYNC_START',
  ASYNC_END: 'ASYNC_END',

  SETTINGS: 'SETTINGS',
  CURRENT_USER: 'CURRENT_USER',
  PASSWORD_CHANGE_DATE: 'PASSWORD_CHANGE_DATE',

  OIDC: 'OIDC',
  AZURE: 'AZURE',
  OKTA: 'OKTA',
  AUTH_BY: 'AUTH_BY',
  API_TOKEN: 'API_TOKEN',
  OKTA_TOKEN: 'okta-token-storage',
  CONFIGURATION: 'CONFIGURATION'
};
